var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "25px",
    viewBox: "0 0 28 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "03-twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-D---CDP",
    transform: "translate(-1220.000000, -7697.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer-updated",
    transform: "translate(0.000000, 7536.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-DSK/V1",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(1116.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-twitter",
    transform: "translate(104.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,2.87230846 C26.9703855,3.36005782 25.863074,3.68918407 24.7005162,3.83683629 C25.8869458,3.07917917 26.7974853,1.87874722 27.2265529,0.447502604 C26.1164563,1.14982045 24.887569,1.659754 23.578711,1.93469262 C22.531079,0.744079909 21.0379534,0 19.3858527,0 C16.2134011,0 13.6413259,2.74296124 13.6413259,6.12611244 C13.6413259,6.606164 13.6920819,7.07348691 13.7900701,7.52183809 C9.0157623,7.26671979 4.78260605,4.82803365 1.94936169,1.12139316 C1.45504445,2.02585393 1.17170864,3.07802753 1.17170864,4.20117845 C1.17170864,6.32643699 2.18580641,8.20136561 3.72718729,9.30027151 C2.7857849,9.26802562 1.89962873,8.99278394 1.1253291,8.53370434 C1.12481756,8.55916161 1.12481756,8.58492196 1.12481756,8.61128843 C1.12481756,11.5788798 3.10498527,14.0548427 5.7331593,14.6180547 C5.25106215,14.7577667 4.74350173,14.8329263 4.21951522,14.8329263 C3.84899042,14.8329263 3.48932162,14.7947404 3.1385195,14.7228539 C3.86984985,17.1565091 5.99125918,18.9278509 8.50456427,18.9772501 C6.53854914,20.6204569 4.06184751,21.5997742 1.37012896,21.5997742 C0.90667457,21.5997742 0.449585998,21.5704377 0,21.5142499 C2.54269017,23.252679 5.56190739,24.2666667 8.80591761,24.2666667 C19.3724958,24.2666667 25.1501022,14.9317854 25.1501022,6.83637054 C25.1501022,6.57119055 25.1451005,6.30631362 25.1340171,6.04380057 C26.2560497,5.18019268 27.2304179,4.10116771 28,2.87230846 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cbb1ab4bf9c1bc560b260203977e0690.svg";
export { ForwardRef as ReactComponent };